import { CheckCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';

export const IntakeSuccessView = ({ onNavigateHome }) => (
  <div className="min-h-screen bg-gradient-to-b from-warmBeige to-white flex items-center justify-center px-4">
    <Card className="max-w-lg w-full shadow-2xl border-none text-center">
      <CardContent className="p-10 space-y-6">
        <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center mx-auto">
          <CheckCircle className="text-white" size={40} />
        </div>
        <h2 className="text-3xl font-bold text-darkBrown">Thank You!</h2>
        <p className="text-gray-600 text-lg">
          Your intake form has been submitted. Our team will review it before your appointment.
        </p>
        <Button
          data-testid="intake-back-home-btn"
          onClick={onNavigateHome}
          className="bg-primaryOrange hover:bg-accentOrange text-white px-8"
        >
          Back to Home
        </Button>
      </CardContent>
    </Card>
  </div>
);
